import React, { useContext, useState, useRef } from 'react';
import ReactDOM from 'react-dom';
import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';
import { DefaultButton, IconButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Card, Col, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { compareTwoDates, getGridLocalization, isNullUndefinedOrEmpty } from "../../../../common/Helpers";
import MessageBox from "../../../../components/Common/Message/MessageBox";
import { __MessageTypes } from "../../../../common/Dictionaries";
import MainAppContext from "../../../../MainAppContext";
import * as XLSX from 'xlsx';

import ProfileVerify from "../../../../components/Templates/Site/ProfileVerify";
import TemplateDoc from '../../../../templates/sKPI/Mantainers/tmp_TypeOfs.csv'
import MatrixToolbar from '../../../../components/Products/sPrivilege/Matrix/MatrixToolbar';
import { useGetContractModificationMaintainer } from '../../../../hooks/services/sKPI/useOfContractModification';
import SidePanelEdit from './SidePanelEdit';
import { useGetContracts } from '../../../../hooks/services/sBook/useOfContract';
import { useGetContractModalitys } from '../../../../hooks/services/sBook/useOfContractModality';
import { __OBJECT_STRUCTURE_ContractModification } from '../../../../common/ObjectStructures/sKPI';
import moment from 'moment';
import { Checkbox, Dialog, DialogFooter, DialogType } from '@fluentui/react';
import 'jqwidgets-scripts/jqwidgets/styles/jqx.light.css';
import { deleteContractModification } from '../../../../services/sKPI/contractModification.service';
import { useBoolean } from '@fluentui/react-hooks';

export default function ContractModification(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const profileHasAccess = !contextSite.onlyObserver || (contextSite.securityProps.isSAdmin ||  contextSite.securityProps.isAdmin)
    
    const gridRef = useRef();

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    
    const [isAddPanelMode, setIsAddPanelMode] = useState(false);
    const [currentItem, setCurrentItem] = useState(__OBJECT_STRUCTURE_ContractModification());
    const [isPanelEditOpen, setIsPanelEditOpen] = useState(false);
    const [showRequiredGlobalMessage, setShowRequiredGlobalMessage] = useState(false);
    const [isDialogDeleteMessageVisible, { setTrue: showDeleteMessageDialog, setFalse: hideDeleteMessageDialog }] = useBoolean(false);

    const [listContract, setListContract] = useState(null);
    useGetContracts(listContract, setListContract)

    const [listContractModalitys, setListContractModalitys] = useState(null);
    useGetContractModalitys(listContractModalitys, setListContractModalitys)

    const [listContractModification, setListContractModification] = useState(null);
    useGetContractModificationMaintainer(listContractModification, setListContractModification);
    
    const getValue = (column, row) => {
        const itemValue = column.editorOptions.find(x => (x.id === row[column.dataField])||(x.key === row[column.dataField]))

        return !isNullUndefinedOrEmpty(itemValue) ? itemValue.name : "";
    }

    const handleExportData = (exportData) => {
        const workbook = XLSX.utils.book_new();

        const aux_rows = []

        if (exportData) {
            listContractModification.forEach(row => {
                let aux_row = {};
                columns.forEach(column => {
                    if (column.exportable) {
                        if (column.columntype === 'dropdownlist') {
                            aux_row[column.dataField] = row[column.dataField] !== null ? getValue(column, row) : "";
                        }
                        else {
                            aux_row[column.dataField] = row[column.dataField];
                        }
                    }
                });
    
                aux_rows.push(aux_row);
            });
        }

        const worksheet = XLSX.utils.json_to_sheet(aux_rows, { header: columns.filter(x => (exportData ? x.exportable : x.uploadMasive)).map(column => column.dataField) });
        
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');

        if (exportData) {
            XLSX.writeFile(workbook, 'TypeOf_ExportedData.xlsx');
        }
        else {
            XLSX.writeFile(workbook, 'TypeOf_UploadTemplate.xlsx');
        }
    };

    const handlerAdd = async (itemId) => {   
        if (!isNullUndefinedOrEmpty(itemId)) {
            const item = gridRef.current.props.source.records.find(x => parseInt(x.id) === itemId);
            setCurrentItem(item);
        }
        else {
            setCurrentItem(__OBJECT_STRUCTURE_ContractModification());
        }

        setIsAddPanelMode(true);
        setIsPanelEditOpen(true);
    };

    const handlerEdit = async (itemId) => {   
        if (!isNullUndefinedOrEmpty(itemId)) {
            const item = gridRef.current.props.source.records.find(x => parseInt(x.id) === itemId);
            setCurrentItem(item);
        }
        else {
            setCurrentItem(__OBJECT_STRUCTURE_ContractModification());
        }

        setIsAddPanelMode(false);
        setIsPanelEditOpen(true);
    };

    const onDeleteItem = (contractModificationId) => {
        deleteContractModification(contractModificationId).then((response) => {
            if (response.data.succeeded) {
                const newListContractModification = listContractModification.filter(x => x.id !== contractModificationId);
                setListContractModification(newListContractModification)

                setMessageConfig({ message : t('data-lang-msg-operationperformed'), messageType : "success", showMessage : true })

                hideDeleteMessageDialog();
            }
            else {
                setMessageConfig({ message : t('data-lang-msg-operationerror'), messageType : "error", showMessage : true })
            }
        }).catch(() => {
            setMessageConfig({ message : t('data-lang-msg-operationerror'), messageType : "error", showMessage : true })
        });
    }

    const onHideDeleteMessageDialog = (ev) => {
        ev.preventDefault();
        hideDeleteMessageDialog();
    };

    const actionCellsRenderer = (objSource) => {
        const itemId = getRowIdFromRowIndex(objSource)
        const item = listContractModification.find(x => x.id === itemId);
        const mc_date_before_today = item ? !compareTwoDates(item.startDate, moment().format('YYYY-MM-DD')) : false

        const canDelete_with_alert = !item.modificacion_consumida_por_ep && !mc_date_before_today && contextSite.securityProps.isSAdmin;
        const canDelete_without_alert = !item.modificacion_consumida_por_ep && mc_date_before_today && contextSite.securityProps.isSAdmin;

        const canEdit = contextSite.securityProps.isSAdmin === false ?
            !item.modificacion_consumida_por_ep :
            !item.modificacion_consumida_por_ep;

        return  <>
                    {
                        canDelete_with_alert &&
                        <IconButton iconProps={{ iconName: 'Delete' }} title={t('data-lang-btn-delete')} ariaLabel={t('data-lang-btn-delete')} onClick={() => fieldActionHandler(itemId, 'delete_withalert')} />
                    }
                    {
                        canDelete_without_alert &&
                        <IconButton iconProps={{ iconName: 'Delete' }} title={t('data-lang-btn-delete')} ariaLabel={t('data-lang-btn-delete')} onClick={() => fieldActionHandler(itemId, 'delete')} />
                    }
                    <IconButton iconProps={{ iconName: canEdit ? 'Edit' : 'View' }} title={canEdit ? t('data-lang-btn-edit') : t('data-lang-btn-view')} ariaLabel={canEdit ? t('data-lang-btn-edit') : t('data-lang-btn-view')} onClick={() => fieldActionHandler(itemId, 'edit')} />
                </>
    };

    const modificationTypeCellsRenderer = (objSource) => {
        const itemId = getRowIdFromRowIndex(objSource)
        const item = listContractModification.find(x => x.id === itemId);

        return  <Row className='mx-auto pt-2'>
            <Col><Checkbox label={t('data-lang-lbl-modificationscope')} disabled={true} checked={item.modificationScope} /></Col>
            <Col><Checkbox label={t('data-lang-lbl-modificationamount')} disabled={true} checked={item.modificationAmount} /></Col>
            <Col><Checkbox label={t('data-lang-lbl-modificationterm')} disabled={true} checked={item.modificationTerm} /></Col>
            <Col><Checkbox label={t('data-lang-lbl-modificationendowment')} disabled={true} checked={item.modificationEndowment} /></Col>
        </Row>
    };

    const fieldActionHandler = (itemId, actionType) => {
        switch (actionType) {
            case 'edit':
                handlerEdit(itemId)
                break;
            case 'delete_withalert':
                const item = gridRef.current.props.source.records.find(x => parseInt(x.id) === itemId);
                setCurrentItem(item);
                showDeleteMessageDialog();
                break;
            case 'delete':
                onDeleteItem(itemId)
                break;
        }
    };

    const getRowIdFromRowIndex = (rowIndex) => {
        if (typeof rowIndex === 'object' && rowIndex.boundindex !== undefined) {
            return listContractModification[rowIndex.boundindex].id;
        }
        return listContractModification[rowIndex]?.id;
    };

    const setterListContractModification = (list) => {
        setListContractModification(list);
        if (gridRef.current) {
            gridRef.current.updatebounddata('cells');
        }
    }

    const columns = [
        { index: null, text: 'ID',                                          dataField: 'id',                    uploadMasive: false, exportable: false, width: '0%',  columntype: 'textbox', hidden: true },
        { index: null, text: t('data-lang-lbl-actions'),                    dataField: 'acciones',              uploadMasive: false, exportable: false, width: '5%', pinned: true, filterable: false, sortable: false,
            createwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
            initwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
        },
        { index: 0,    text: t('data-lang-lbl-changecode'),                 dataField: 'changeCode',            uploadMasive: false, exportable: true, width: '180px', columntype: 'textbox', pinned: true },  
        { index: 1,    text: t('data-lang-lbl-changesecnumber'),            dataField: 'changeSecNumber',       uploadMasive: false, exportable: true, width: '180px', columntype: 'numberinput',    cellsformat: 'n2', cellsalign: 'right' },
        
        { index: 2,    text: t('data-lang-lbl-contractcode'),               dataField: 'contractCode',          uploadMasive: false, exportable: true, width: '180px', columntype: 'textbox' },
        { index: 3,    text: t('data-lang-lbl-contractname'),               dataField: 'contractId',            uploadMasive: false, exportable: true, width: '250px', columntype: 'dropdownlist',   displayfield: 'Contract_Id', editorOptions: listContract },
        { index: 4,    text: t('data-lang-lbl-typeofcontractmodification'), dataField: 'contractingModalityId', uploadMasive: false, exportable: true, width: '180px', columntype: 'dropdownlist',   displayfield: 'ContractingModality_Id', editorOptions: listContractModalitys },  
        { index: 5,    text: t('data-lang-lbl-reason'),                     dataField: 'reason',                uploadMasive: false, exportable: true, width: '300px', columntype: 'textbox' },
        { index: 6,    text: t('data-lang-lbl-scope'),                      dataField: 'scope',                 uploadMasive: false, exportable: true, width: '300px', columntype: 'textbox' },
        { index: 7,    text: t('data-lang-lbl-comingintoeffect'),           dataField: 'startDate',             uploadMasive: false, exportable: true, width: '200px', columntype: 'datetimeinput',  cellsformat: 'dd-MM-yyyy' },
        { index: 8,    text: t('data-lang-lbl-term'),                       dataField: 'term',                  uploadMasive: false, exportable: true, width: '120px', columntype: 'datetimeinput',  cellsformat: 'dd-MM-yyyy' },
        { index: 9,    text: t('data-lang-lbl-amount'),                     dataField: 'amount',                uploadMasive: false, exportable: true, width: '200px', columntype: 'numberinput',    cellsformat: 'd3', cellsalign: 'right' },
        { index: 10,   text: t('data-lang-lbl-endowment'),                  dataField: 'endowment',             uploadMasive: false, exportable: true, width: '100px', columntype: 'numberinput',    cellsformat: 'd', cellsalign: 'right' },
        { index: 11,   text: t('data-lang-lbl-modificationscope'),          dataField: 'modificationScope',     uploadMasive: false, exportable: true, width: '150px', columntype: 'checkbox', hidden: true },
        { index: 12,   text: t('data-lang-lbl-modificationamount'),         dataField: 'modificationAmount',    uploadMasive: false, exportable: true, width: '150px', columntype: 'checkbox', hidden: true },
        { index: 13,   text: t('data-lang-lbl-modificationterm'),           dataField: 'modificationTerm',      uploadMasive: false, exportable: true, width: '150px', columntype: 'checkbox', hidden: true },
        { index: 14,   text: t('data-lang-lbl-modificationendowment'),      dataField: 'modificationEndowment', uploadMasive: false, exportable: true, width: '150px', columntype: 'checkbox', hidden: true },
        { index: null, text: t('data-lang-lbl-modificationtype'),           dataField: 'modificationtype',      uploadMasive: false, exportable: false,width: '500px', filterable: false, sortable: false,
            createwidget: (row, column, value, htmlElement) => { ReactDOM.render(modificationTypeCellsRenderer(row), htmlElement); },
            initwidget: (row, column, value, htmlElement) => { ReactDOM.render(modificationTypeCellsRenderer(row), htmlElement); },
        },
        { index: null, text: t('data-lang-lbl-modificationusername'),                                          dataField: 'userfullname',          uploadMasive: false, exportable: true, width: '200px',  columntype: 'textbox', editable: false },
        { index: null, text: t('data-lang-lbl-modificationdate'),                                              dataField: 'modDate',               uploadMasive: false, exportable: true, width: '200px',  columntype: 'textbox', editable: false, cellsformat: 'dd-MM-yyyy - HH:mm:ss', cellsalign: 'right' },
    ]

    return (
        <div className="col-12 listWithActions h-100">
            <Card className="h-100">
                <Card.Header>
                    <Card.Title className="d-flex justify-content-between">
                        <h4><b>{t('data-lang-maintainer-title-contractmodification')}</b></h4>
                    </Card.Title>
                </Card.Header>
                <Card.Footer>
                    <MessageBox  
                        inputParam_Message={ messageConfig.message }
                        inputParam_Display={ messageConfig.showMessage }
                        inputParam_MessageType={ messageConfig.messageType }
                        inputParam_SetterMessage={ setMessageConfig }
                    />
                </Card.Footer>
                <Card.Body className="access-per-month-form-body h-100 overflow-hidden-deprecated">
                    <div className="d-none">
                        <a id="btnGetTemplate" href={TemplateDoc} download="TypeOfTemplate.csv" style={{display: "none"}} rel="noreferrer noopener" target='_blank'>#</a>
                    </div>
                    {
                        listContract !== null && listContractModalitys !== null && listContractModification !== null && 
                        <div className="align-items-center h-100">
                            <MatrixToolbar
                                inputParam_HandleSaveData={null}
                                inputParam_HandleUploadData={null}
                                inputParam_HandleExportData={handleExportData}
                                inputParam_HandleAddRow={handlerAdd}
                                inputParam_Configuration={{
                                    buttons: {
                                        showAddData: profileHasAccess,
                                        showExportData: true,
                                        showRowButtons: false,
                                        showAddMasiveData: false,
                                        showDownloadTemplate: false,
                                        showSaveAllData: false,
                                        groupedButtons: false
                                    },
                                    handlers: {
                                        handlerSave: profileHasAccess ? handlerEdit : null,
                                        handlerSaveAll: null,
                                        handlerDelete: null,
                                        handlerCancel: null,
                                    },
                                    auxiliarListCallbackOnAdd: null,
                                }}
                                inputParam_ExternalExportTemplates={null}
                                inputParam_CustomOpenPanel={null}
                                showRequiredMessage={showRequiredGlobalMessage}
                            />
                            <JqxGrid
                                ref={gridRef}
                                altrows={true}
                                enabletooltips={true}
                                width={'100%'}
                                theme={'light'} 
                                height={'500px'}
                                editable={false}
                                //pageable={true}
                                sortable={true}
                                filterable={true}
                                showfilterrow={true} 
                                localization={getGridLocalization(t)}
                                source={ new jqx.dataAdapter({
                                    localData: listContractModification,
                                    dataType: 'array',
                                    dataFields: [
                                        { name: 'id',                    type: 'number' },
                                        
                                        { name: 'contractId',            type: 'number' },
                                        { name: 'Contract_Id',            value:'contractId', values: { source: listContract, value: 'id', name: 'name' } },
                                        
                                        { name: 'contractingModalityId', type: 'number' },
                                        { name: 'ContractingModality_Id', value:'contractingModalityId', values: { source: listContractModalitys, value: 'key', name: 'name' } },
                                        
                                        { name: 'changeCode',            type: 'string' },
                                        { name: 'changeSecNumber',       type: 'number' },
                                        { name: 'contractCode',          type: 'string' },
                                        
                                        { name: 'reason',                type: 'string' },
                                        { name: 'scope',                 type: 'string' },

                                        { name: 'amount',                type: 'float' },
                                        { name: 'endowment',             type: 'number' },

                                        { name: 'startDate',             type: 'date' },
                                        { name: 'term',                  type: 'date' },

                                        { name: 'modificacion_consumida_por_ep',     type: 'bool' },

                                        { name: 'modificationScope',     type: 'bool' },
                                        { name: 'modificationAmount',    type: 'bool' },
                                        { name: 'modificationTerm',      type: 'bool' },
                                        { name: 'modificationEndowment', type: 'bool' },

                                        { name: 'userfullname',          type: 'string' },
                                        { name: 'modDate',               type: 'date' },
                                    ],
                                    id: 'id'
                                })}
                                columns={columns}
                            />
                        </div>
                    }
                </Card.Body>
            </Card>
            {
                currentItem.id > 0 !== null && isDialogDeleteMessageVisible &&
                <Dialog
                    hidden={!isDialogDeleteMessageVisible}
                    onDismiss={onHideDeleteMessageDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-delete-message'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={() => onDeleteItem(currentItem.id)} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDeleteMessageDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            }
            {
                listContract !== null && listContractModification !== null && listContractModalitys !== null && isPanelEditOpen &&
                <SidePanelEdit
                    inputParam_IsPanelOpen={isPanelEditOpen}
                    inputParam_IsAdd={isAddPanelMode}
                    inputParam_SetterIsPanelOpen={setIsPanelEditOpen}
                    inputParam_ContractModification={currentItem}
                    inputParam_ContractList={listContract}
                    inputParam_ContractModalitysList={listContractModalitys}
                    inputParam_ListContractModification={listContractModification}
                    inputParam_SetListContractModification={setterListContractModification}
                />
            }          
        </div>
    ); 
}